import { streamFixed } from "../../../i18n/streamingPagesPresentation";
import { stUnit, stAgo, streamLocale } from "../../../i18n/streamingPagesPresentation";
import { stText } from "../../../i18n/streamingPagesPresentation";
/**
 * Shared formatting helpers for the UserAdminPanel and its tab sub-components.
 *
 * These are small pure functions extracted to avoid duplication across tabs.
 */

export const formatDuration = (secs: number): string => {
  if (secs < 60) return stUnit(secs, "second");
  if (secs < 3600) return stUnit(Math.floor(secs / 60), "minute");
  const hours = Math.floor(secs / 3600);
  const mins = Math.floor((secs % 3600) / 60);
  return mins > 0 ? `${hours}h ${mins}m` : stUnit(hours, "hour");
};

export const formatRelativeTime = (input: number | string | null): string => {
  if (input == null) return stText("never");

  let ms: number;
  if (typeof input === "string") {
    ms = new Date(input).getTime();
    if (isNaN(ms)) return stText("unknown");
  } else {
    ms = input < 1e12 ? input * 1000 : input;
  }

  const diff = Date.now() - ms;
  if (diff < 0) return stText("justNow");
  if (diff < 60_000) return stText("justNow");
  if (diff < 3600_000) return stAgo(Math.floor(diff / 60_000), "minute");
  if (diff < 86400_000) return stAgo(Math.floor(diff / 3600_000), "hour");
  if (diff < 2592000_000) return stAgo(Math.floor(diff / 86400_000), "day");
  return new Date(ms).toLocaleDateString(streamLocale(), { dateStyle: "medium" });
};

export const formatTimestamp = (input: number | string | null): string => {
  if (input == null) return "--";
  let ms: number;
  if (typeof input === "string") {
    ms = new Date(input).getTime();
    if (isNaN(ms)) return "--";
  } else {
    ms = input < 1e12 ? input * 1000 : input;
  }
  return new Date(ms).toLocaleDateString(streamLocale(), { dateStyle: "medium" });
};

export const formatFullTimestamp = (input: number | string | null): string => {
  if (input == null) return "--";
  let ms: number;
  if (typeof input === "string") {
    ms = new Date(input).getTime();
    if (isNaN(ms)) return "--";
  } else {
    ms = input < 1e12 ? input * 1000 : input;
  }
  return new Date(ms).toLocaleString(streamLocale(), {
    dateStyle: "medium",
    timeStyle: "short",
  });
};

export const formatBitrate = (bps: number | null): string => {
  if (!bps) return "--";
  if (bps >= 1_000_000) return `${streamFixed((bps / 1_000_000), 1)} Mbps`;
  if (bps >= 1_000) return `${Math.round(bps / 1_000)} Kbps`;
  return `${bps} bps`;
};
